// extracted by mini-css-extract-plugin
export var body = "_cp-8";
export var button = "_cp-0";
export var closeButton = "_cp-5";
export var content = "_cp-3";
export var empty = "_cp-f";
export var grid = "_cp-c";
export var header = "_cp-4";
export var icon = "_cp-1";
export var option = "_cp-d";
export var optionSelected = "_cp-e";
export var overlay = "_cp-2";
export var searchIcon = "_cp-a";
export var searchInput = "_cp-b";
export var searchWrapper = "_cp-9";
export var title = "_cp-6";
export var visuallyHidden = "_cp-7";